import { render } from "./sidebarItem.vue?vue&type=template&id=50b51800"
import script from "./sidebarItem.vue?vue&type=script&lang=js"
export * from "./sidebarItem.vue?vue&type=script&lang=js"

import "./sidebarItem.vue?vue&type=style&index=0&id=50b51800&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__